import { isObligationPortfolioResponse, } from '@urbanik/api-contracts';
export class ObligationPortfolioApiError extends Error {
    kind;
    constructor(kind, message) {
        super(message);
        this.kind = kind;
        this.name = 'ObligationPortfolioApiError';
    }
}
export async function getObligationPortfolio(base, input = {}, signal) {
    const url = new URL(`${base.replace(/\/$/, '')}/identity/collections/obligations`);
    Object.entries(input).forEach(([key, value]) => {
        if (value !== undefined && value !== '')
            url.searchParams.set(key, String(value));
    });
    let response;
    try {
        response = await fetch(url, {
            credentials: 'include',
            headers: { Accept: 'application/json' },
            signal: signal ?? null,
        });
    }
    catch {
        throw new ObligationPortfolioApiError('unavailable', 'No pudimos consultar la cartera.');
    }
    const body = await response.json().catch(() => null);
    if (!response.ok) {
        const message = typeof body === 'object' &&
            body !== null &&
            'message' in body &&
            typeof body.message === 'string'
            ? body.message
            : 'No pudimos consultar la cartera.';
        throw new ObligationPortfolioApiError(response.status === 401
            ? 'unauthorized'
            : response.status === 403
                ? 'forbidden'
                : response.status === 400
                    ? 'invalid'
                    : 'unavailable', message);
    }
    if (!isObligationPortfolioResponse(body))
        throw new ObligationPortfolioApiError('invalid', 'La cartera recibida no es válida.');
    return body;
}
